/**
 * 표준권역 관리 타입 정의
 */

// ===== DTO (API 응답) =====

export interface SupplierItemDto {
    suppId: string;
    suppName: string;
}

export interface StandardAreaDto {
    seqNo: number;
    areaName: string;
    useYn: string;
    insDate: string | null;
    suppliers: SupplierItemDto[];
}

export interface GetStandardAreasResponseDto {
    totalCount: number;
    areas: StandardAreaDto[];
}

// ===== 요청 =====

export interface SaveStandardAreaRequest {
    seqNo: number | null;
    areaName: string;
    suppIds: string[];
    userId: string;
}

// ===== 폼 상태 (UI 전용) =====

export interface StandardAreaForm {
    seqNo: number | null;
    areaName: string;
    selectedSuppIds: string[];
}

export const DEFAULT_FORM: StandardAreaForm = {
    seqNo: null,
    areaName: '',
    selectedSuppIds: [],
};
